import moment from 'moment';
import { FootballConfig } from './Football';
import { RugbyLeagueConfig } from './RugbyLeague';
import { RugbyUnionConfig } from './RugbyUnion';
export const MatchFormConfig = {
    football: FootballConfig,
    'rugby league': RugbyLeagueConfig,
    'rugby union': RugbyUnionConfig
};
export const MatchFormInitialValues = (match) => {
    var _a, _b, _c;
    const date = new Date((match === null || match === void 0 ? void 0 : match.date) || '');
    const ampm = (date === null || date === void 0 ? void 0 : date.getHours()) > 11 ? 'pm' : 'am';
    return {
        id: match ? match.id : undefined,
        sport: match ? match.competition.sport.name : '',
        competitionId: match ? match.competition.id : '',
        homeTeamId: ((_a = match === null || match === void 0 ? void 0 : match.homeTeam) === null || _a === void 0 ? void 0 : _a.id) || '',
        awayTeamId: ((_b = match === null || match === void 0 ? void 0 : match.awayTeam) === null || _b === void 0 ? void 0 : _b.id) || '',
        venueId: ((_c = match === null || match === void 0 ? void 0 : match.venue) === null || _c === void 0 ? void 0 : _c.id) || '',
        name: (match === null || match === void 0 ? void 0 : match.name) || '',
        date: match ? date.toISOString() : undefined,
        time: match
            ? {
                hours: ampm === 'pm' ? date.getHours() % 12 || 12 : date.getHours() % 12,
                minutes: date.getMinutes(),
                ampm
            }
            : {
                hours: undefined,
                minutes: undefined,
                ampm: 'am'
            }
    };
};
export const formatDateMatches = (date, time) => {
    const dateNew = moment(date).toDate();
    if (time.hours && time.minutes) {
        dateNew.setHours(time.ampm === 'am'
            ? parseInt(time.hours) === 12
                ? 0
                : parseInt(time.hours)
            : parseInt(time.hours) === 12
                ? parseInt(time.hours)
                : parseInt(time.hours) + 12);
        dateNew.setMinutes(parseInt(time.minutes));
    }
    return dateNew;
};
//# sourceMappingURL=index.js.map